import * as React from 'react';
import { Route, Switch } from 'react-router';
import { Redirect } from 'react-router';
import { Championships } from './Championships';
import { ChampionshipWizard } from './ChampionshipWizard';
import { ChampionshipManage } from './ChampionshipManage';

export const ChampionshipsRouting = allProps => {
  return (
    <Switch>
      <Route exact path="/championships" render={() => <Redirect to="/championships/upcoming" />} />
      <Route
        exact
        path={['/championships/upcoming', '/championships/archive']}
        render={props => <Championships {...props} user={allProps.user} />}
      />
      <Route
        exact
        path="/championships/create"
        render={props => <ChampionshipWizard {...props} user={allProps.user} />}
      />
      <Route
        exact
        path="/championships/:championshipId/edit"
        render={props => <ChampionshipWizard {...props} user={allProps.user} />}
      />
      <Route
        exact
        path="/championships/:championshipId/manage"
        render={props => <ChampionshipManage {...props} user={allProps.user} />}
      />
    </Switch>
  );
};
